import { watch, ref } from 'vue';
import { store } from '@/store';
import types from '@/store/types';

export function usePrize () {
  const showPrize = ref(false);
  watch(
    () => store.state.previousPeriodObtainFlag,
    (curren) => {
      if (
        curren &&
        !store.state.hasShowPrizeDialog &&
        store.state.previousPeriodObtainCount > 0
      ) {
        store.commit(types.SET_HAS_PRIZE_DIALOG_OPEN, true);
        showPrize.value = true;
      }
    }
  );
  return { showPrize };
}
